<template>
  <div>
    <BaseList
      :columns="columns"
      :data="TotalInfo && TotalInfo.rows ? TotalInfo.rows : []"
      :pagination="
        TotalInfo
          ? {
              total: TotalInfo.count,
              current: TotalInfo.page,
              pageSize: TotalInfo.limit,
            }
          : {}
      "
      :scroll="{ y: 'calc(100vh - 450px)' }"
      :titleAdd="$t('i18nCommon.AddCustomer')"
      @change="handleTableChange"
      @addData="addData"
      @editRow="editRow"
      @onDblclick="onDblclick"
      @deleteRow="deleteRow"
      @loadDataFilter="loadDataFilter"
    >
    </BaseList>
    <div v-if="isShow && customer && Object.keys(customer)">
      <a-modal v-model:open="isShow" :closable="false" centered :width="800">
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-2xl">
            {{ $t("i18nCommon.TitleDetailInfo") }}
          </div>
          <div
            class="text-white h-9 w-36 bg-slate-900 rounded-lg flex justify-center items-center"
          >
            {{ $t("i18nCommon.Customer") }}
          </div>
        </div>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="customer"
              label-width="120px"
              class="demo-ruleForm"
              :size="formSize"
              status-icon
            >
              <div class="flex columns-2">
                <a-form-item prop="name" testek="name" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Name") }}
                    </div>
                    <a-input v-model:value="customer.name" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="phoneNum" testek="phoneNum" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Phone") }}
                    </div>
                    <a-input v-model:value="customer.phoneNum" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="email" testek="email" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">Email</div>
                    <a-input v-model:value="customer.email" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="type" testek="type" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Type") }}
                    </div>
                    <a-input v-model:value="customer.type" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="conutry" testek="conutry" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Conutry") }}
                    </div>
                    <a-input v-model:value="customer.country" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="city" testek="city" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.City") }}
                    </div>
                    <a-input v-model:value="customer.city" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="address" testek="address" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Address") }}
                    </div>
                    <a-input v-model:value="customer.address" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="postalCode" testek="postalCode" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.PostalCode") }}
                    </div>
                    <a-input v-model:value="customer.postalCode" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="isShow = false">{{
            $t("i18nCommon.Close")
          }}</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>
<script>
import BaseList from "@/views/base/BaseList.vue";
import dataFake from "@/data/dataFake";
import { mapGetters, mapActions } from "vuex";
import { ModuleCustomer } from "@/store/module-const";
import { Modal } from "ant-design-vue";
export default {
  name: "CustomerList",
  components: {
    BaseList,
  },
  data() {
    return {
      dataSource: dataFake.Products,
      columns: [],
      pagination: {
        total: 200,
        current: 1,
        pageSize: 20,
      },
      customer: {},
      isShow: false,
    };
  },
  computed: {
    ...mapGetters(ModuleCustomer, ["TotalInfo"]),
  },
  async created() {
    const me = this;
    me.initDataStatic();
    await me.loadDataGrid();
  },
  methods: {
    ...mapActions(ModuleCustomer, [
      "getCustomers",
      "updateOrder",
      "deleteCustomer",
      "getCustomer",
    ]),
    handleTableChange: _.debounce(async function (page) {
      const me = this;
      me.pagination.current = page.current;
      me.pagination.pageSize = page.pageSize;
      me.pagination.total = page.total;
      await me.loadDataGrid();
    }, 300),
    initDataStatic() {
      const me = this;
      me.columns = [
        // {
        //   title: me.$t("i18nProduct.Id"),
        //   dataIndex: "Id",
        // },
        {
          fixed: "left",
          title: me.$t("i18nCommon.CustomerInfo.Name"),
          dataIndex: "name",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.name, b.name),
          width: 250,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.CustomerInfo.PhoneNumber"),
          dataIndex: "phoneNum",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.phoneNum, b.phoneNum),
          width: 200,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.CustomerInfo.Email"),
          dataIndex: "email",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.email, b.email),
          width: 250,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.CustomerInfo.Country"),
          dataIndex: "country",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.country, b.country),
          width: 250,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.CustomerInfo.City"),
          dataIndex: "city",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.city, b.city),
          width: 250,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.CustomerInfo.Address"),
          dataIndex: "address",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.address, b.address),
          width: 250,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.CustomerInfo.PostalCode"),
          dataIndex: "postalCode",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.postalCode, b.postalCode),
          width: 200,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.CustomerInfo.Status"),
          dataIndex: "status",
          width: 150,
          align: "center",
        },
        {
          title: me.$t("i18nCommon.CustomerInfo.Type"),
          dataIndex: "type",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.type, b.type),
          width: 150,
        },
        {
          title: me.$t("i18nCommon.CustomerInfo.Guest"),
          dataIndex: "guest",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.guest, b.guest),
          width: 200,
        },
        {
          title: me.$t("i18nCommon.Action"),
          key: "rightWidgetDefault",
          fixed: "right",
          width: 150,
        },
      ];
    },

    async loadDataGrid() {
      const me = this;
      let payload = {
        ...me.payload,
        limit: me.pagination.pageSize,
        page: me.pagination.current,
      };
      await me.getCustomers(payload);
    },
    loadDataFilter: _.debounce(async function (params) {
      const me = this;
      let payload = {
        ...me.payload,
        ...params,
        limit: me.pagination.pageSize,
        page: 1,
      };
      await me.getCustomers(payload);
    }, 300),
    addData() {
      const me = this;
      me.$router.push("/create-customer");
    },
    async deleteRow(dataRow) {
      const me = this;
      if (!dataRow) return;
      await me.deleteCustomer({ Id: dataRow.Id });
    },

    editRow: _.debounce(async function (dataRow) {
      const me = this;
      if (!dataRow) return;
      me.$router.push("/create-customer");
      setTimeout(() => {
        me.$emitter.emit("LoadEditCustomer", {
          id: dataRow.id,
          mode: me.$enum.Mode.Edit,
        });
      }, 300);
    }, 300),

    deleteRow: _.debounce(async function (dataRow) {
      const me = this;
      if (!dataRow) {
        me.$messageNotification.messageNotification(
          me.$t("i18nCommon.DeleteCustomerFail"),
          "warning"
        );
        return;
      }

      Modal.confirm({
        title: me.$t("i18nCommon.Confirm"),
        content: me.$t("i18nCommon.DeleteCustomerConfirm", {
          name: dataRow.name,
        }),
        okText: me.$t("i18nCommon.Yes"),
        cancelText: me.$t("i18nCommon.No"),
        centered: true,
        async onOk() {
          let result = await me.deleteCustomer({ id: dataRow.id });
          if (result && result.code == 200) {
            await me.loadDataGrid();
            //Thông báo
            me.$messageNotification.messageNotification(
              me.$t("i18nCommon.DeleteCustomerSuccess")
            );
          } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
            me.$messageNotification.messageNotification(result.message, "warning");
          } else {
            me.$messageNotification.messageNotification(
              me.$t("i18nCommon.DeleteCustomerFail"),
              "warning"
            );
          }
        },
      });
    }, 300),

    async onDblclick(params) {
      const me = this;
      if (!params || !params.id) return;

      //lấy dữ liệu chi tiết từ API
      me.customer = await me.getCustomer({ id: params.id });
      if (me.customer) {
        me.isShow = true;
      } else {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
}
</style>
